import Lottie from "lottie-react";
import Lottie1 from "../../assets/lotties/hyperaligned.json";
import MobileLottie from "../../assets/lotties/hyperaligned-mobile.json";

const NewSlide4 = () => {
  return (
    <div className="xl:h-screen snap-start w-full bg-[#062824] xl:scale-70 py-8 xl:py-0">
      <Lottie animationData={Lottie1} className="hidden xl:block h-[100vh]" />
      <Lottie animationData={MobileLottie} className="block xl:hidden" />
    </div>
  );
};

export default NewSlide4;
